<div class="mat-dialog-content" [ngClass]="{'content-height': results.length > 0}">
	<div class="header">
		<div class="close-button" (click)="closeDialog()">
			<span class="cross">
				X
			</span>
		</div>
		<div class="back-pattern">
			<div class="quarter-circle"><img class="circle" src="/assets/img/icons-patterns-circle-solid.svg" /></div>
			<div class="half-circle">
				<img src="/assets/img/whitespots_cropped_image.png" class="spots-white-in-circle" />
			</div>
		</div>
		<div class="header-title">
			<span>Search International Call Rates</span>

		</div>
	</div>
	<div class="content">
		<div class="content--info">
			Enter the destination below to receive our per minute mobile call rates
			to that particular country.
		</div>
		<form [formGroup]="form">
			<div class="content--form">
				<div class="col-sm-8 col-xs-8">
					<tc-autocomplete-field controlName="country" label="Country" placeholder="Country"
						keyRestrictions="alpha-only" [scroll]="true" [selfFilter]="false" displayOption="countryRate"
						(selection)="handleCountrySelection($event)" [setOptions]="filteredCountries">
					</tc-autocomplete-field>

				</div>
				<div class="col-sm-4 col-xs-4">
					<secondary-button color="secondary" (clicked)="formSubmit()" [height]="55"
						[disabled]="form.invalid || !countryExist" [theme]="buttonTheme">
						Search </secondary-button>
				</div>
			</div>
		</form>
		<div *ngIf="results && results.length > 0">
			<div class="content--title">{{results[0].key}} call rates</div>
			<div class="content__data">
				<div *ngFor="let item of results; index as i;">
					<div class="content__data--key">Dodo mobile to international country </div>
					<div class="content__data--rate content__data--rate-{{i}}">
						${{item.rate}} per minute
					</div>

				</div>
			</div>

		</div>
		<a class="content--link" href="https://www.dodo.com/mobile/international-call-rates"
			target="_blank">
			Full list of countries and rates
		</a>


	</div>

</div>